export default __webpack_public_path__ + "static/B0207-a317471269a8edc6fa86b58683521563.png";